
<div class="div-header" style="background-image: url('./assets/images/header.gif');">
	<div class="row">
		<div class="col-3 col-sm-3 col-md-3 col-lg-2 col-xl-4 mainlogo">
			<a href="https://www.kwsp.gov.my/">
				<img src="./assets/images/logo-kwsp.svg" alt="KWSP">
			</a>
		</div>
		
		<div class="col-6 col-sm-4 col-md-3 col-lg-3 col-xl-3 title">
			<h1 >{{ 'HeaderTitle' | translate }}</h1> 
		</div>
		
		<div class="col-3 col-sm-5 col-md-6 col-lg-7 col-xl-5 infos">			
			<ul class="row right-item">
				<li class="col-sm-12 col-md-12 col-lg-10">
					<div class="info">
						<img src="./assets/images/icon_hp.gif"> 
						<span >{{ 'epfCMC' | translate }}</span>
           				<span >{{ 'epfCMCNo' | translate }}</span>
					</div>
				</li>
				<ul class="col-12 col-sm-4 col-lg-2 language">
					<li #langSelect *ngFor="let lang of translate.getLangs()" [value]="lang" (click)="changeLang(lang, $event)">
						<a class="text-uppercase">{{ 'language.'+lang | translate  }}</a>
					</li>
				</ul>
			</ul>
		</div>
	</div>
	
</div> 